export const faqSectionSearchItemTemplate = (item, {html, components}) => {
    const {url, questions = [], _highlightResult = {}, objectID, __position, __queryID} = item;

    const highlightedTitle = components.Highlight({
        attribute: 'title',
        hit: item,
        highlightedTagName: 'b',
    });

    /**
     * @param {object} question
     * @param {number} index
     * @returns {object}
     */
    function mapHighlightsToQuestions(question, index) {
        return {
            ...question,
            _highlightResult: {
                ..._highlightResult.questions[index],
            },
        };
    }

    /**
     * @param {object} root0
     * @param {object} root0._highlightResult
     * @returns {number}
     */
    function matchedQuestionsFilter({_highlightResult}) {
        return _highlightResult.question.matchedWords.length;
    }

    /**
     * @param {Array<object>} questions
     * @returns {string|null}
     */
    function generateHtmlForMatchedQuestions(questions) {
        if (!questions.length) {
            return null;
        }

        const matchedLessons = questions.map(mapHighlightsToQuestions).filter(matchedQuestionsFilter);

        if (!matchedLessons.length) {
            return;
        }

        return html`<h4 class="searchItem__lessonItemHeading mb-small mt-small h5 font-normal">Frequently Asked Questions</h4>
            <ul>
                ${matchedLessons.map((question) => {
                    const highlight = components.Highlight({
                        attribute: 'question',
                        hit: question,
                        highlightedTagName: 'b',
                    });
                    return html`<li class="searchItem__lessonItem">${highlight}</li>`;
                })}
            </ul>`;
    }

    return html`
        <div
            data-insights-object-id="${objectID}"
            data-insights-position="${__position}"
            data-insights-query-id="${__queryID}"
            class="searchItem searchItem--link pb-small"
        >
            <div class="searchItem__type">FAQ Section</div>
            <h4 class="searchItem__heading h3 mt-none">
                <a class="searchItem__link" href="${url}"> ${highlightedTitle} </a>
            </h3>
            ${generateHtmlForMatchedQuestions(questions)}
            <div class="searchItem__callToAction link">View FAQ Section</div>
        </div>
    `;
};
